// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/fonts/SofiaPro-Bold.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/fonts/SofiaPro-Medium.otf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  height: 100%;
  width: 100%;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
html {
  height: 100%;
  width: 100%;
}

#root {
  height: 100%;
  width: 100%;
}

.ant-message {
  z-index: 9999; /* Adjust this value to be higher than the default z-index */
}

/* Remove OverlayDrawer built-in open/close animation */
#simplifi-ai-chat,
#simplifi-ai-chat * {
  transition: none !important;
}
code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
    monospace;
}

/* Sofia Pro font family definitions */

@font-face {
  font-family: 'Sofia Pro';
  src:
    local('SofiaPro-Bold'),
    url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('opentype');
  font-weight: bold;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: 'Sofia Pro';
  src:
    local('SofiaPro-Medium'),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('opentype');
  font-weight: 400;
  font-style: normal;
  font-display: swap;
}

/* Add other font styles and weights as needed */
/* @font-face rules for 'Black', 'Blackitalic', 'ExtraLight', 'ExtraLightItalic', etc. */
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT,YAAY;EACZ,WAAW;EACX;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa,EAAE,4DAA4D;AAC7E;;AAEA,uDAAuD;AACvD;;EAEE,2BAA2B;AAC7B;AACA;EACE;aACW;AACb;;AAEA,sCAAsC;;AAEtC;EACE,wBAAwB;EACxB;;8DAE6D;EAC7D,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB;;8DAE+D;EAC/D,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,gDAAgD;AAChD,wFAAwF","sourcesContent":["body {\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\nhtml {\n  height: 100%;\n  width: 100%;\n}\n\n#root {\n  height: 100%;\n  width: 100%;\n}\n\n.ant-message {\n  z-index: 9999; /* Adjust this value to be higher than the default z-index */\n}\n\n/* Remove OverlayDrawer built-in open/close animation */\n#simplifi-ai-chat,\n#simplifi-ai-chat * {\n  transition: none !important;\n}\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',\n    monospace;\n}\n\n/* Sofia Pro font family definitions */\n\n@font-face {\n  font-family: 'Sofia Pro';\n  src:\n    local('SofiaPro-Bold'),\n    url('../assets/fonts/SofiaPro-Bold.otf') format('opentype');\n  font-weight: bold;\n  font-style: normal;\n  font-display: swap;\n}\n\n@font-face {\n  font-family: 'Sofia Pro';\n  src:\n    local('SofiaPro-Medium'),\n    url('../assets/fonts/SofiaPro-Medium.otf') format('opentype');\n  font-weight: 400;\n  font-style: normal;\n  font-display: swap;\n}\n\n/* Add other font styles and weights as needed */\n/* @font-face rules for 'Black', 'Blackitalic', 'ExtraLight', 'ExtraLightItalic', etc. */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
